export default "__VITE_ASSET__BvAzUNC7__"